// extracted by mini-css-extract-plugin
export var icon = "_9r-3";
export var subtitle = "_9r-2";
export var title = "_9r-1";
export var value = "_9r-0";